import React from "react";
import { connect } from "react-redux";
import { getArgsQuery } from "../../../utils/GlobalFunction";
import StorageUtil from "../../../utils/reader/serviceUtils/storageUtil";
import { withRouter } from "../../../utils/withRouter";
import "./background.css";

class Background extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSingle:
        StorageUtil.getReaderConfig("readerMode") &&
        StorageUtil.getReaderConfig("readerMode") !== "double",
      currentChapter: "",
      chapterPage: 1,
      chapterPageEnd: 1,
      chapterTotal: 1,
      percentage: 0,
      scale: StorageUtil.getReaderConfig("scale") || 1,
      isHideFooter: StorageUtil.getReaderConfig("isHideFooter") === "yes",
      isHideHeader: StorageUtil.getReaderConfig("isHideHeader") === "yes",
      isDuobleIFrame: document.getElementsByTagName("iframe").length,
      title: getArgsQuery(this.props.history.location.search).title,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      !nextProps.currentEpub.rendition?.location ||
      !this.props.currentEpub?.rendition
    ) {
      return;
    }
    const currentLocation =
      this.props.currentEpub.rendition.currentLocation();
    if (!currentLocation.start) return;

    const chapterPage = currentLocation.start.displayed.page;
    const chapterTotal = currentLocation.start.displayed.total;
    const chapterPageEnd =
      currentLocation.end?.displayed?.page ?? chapterPage;
    let percentage = 0;
    if (nextProps.percentage != null) {
      percentage = Math.round(nextProps.percentage * 100);
    } else {
      try {
        const spineIndex = currentLocation.start.index;
        const spineLength = this.props.currentEpub.book?.spine?.length;
        if (spineLength > 0 && chapterTotal > 0) {
          const chapterProgress = chapterPage / chapterTotal;
          percentage = Math.round(
            ((spineIndex + chapterProgress) / spineLength) * 100
          );
        } else {
          percentage = this.state.percentage;
        }
      } catch (err) {
        percentage = this.state.percentage;
      }
    }

    const stateChanged =
      this.state.chapterPage !== chapterPage ||
      this.state.chapterPageEnd !== chapterPageEnd ||
      this.state.chapterTotal !== chapterTotal ||
      this.state.percentage !== percentage;

    if (stateChanged) {
      this.setState({
        chapterPage,
        chapterPageEnd,
        chapterTotal,
        percentage,
      });
    }

    const chapterHref = currentLocation.start.href;
    let chapter = "";
    const matched = this.props.flattenChapters.filter(
      (item) =>
        item.href.indexOf(chapterHref) > -1 ||
        chapterHref.indexOf(item.href) > -1
    )[0];
    if (matched) chapter = matched.label.trim(" ");
    if (chapter !== this.state.currentChapter) {
      this.setState({ currentChapter: chapter });
    }
  }

  render() {
    return (
      <div
        className="background"
        style={{
          color: StorageUtil.getReaderConfig("textColor")
            ? StorageUtil.getReaderConfig("textColor")
            : "",
        }}
      >
        <div className="header-container">
          {!this.state.isHideHeader && this.state.currentChapter && (
            <p
              className="header-chapter-name"
              style={
                this.state.isSingle
                  ? {
                      left: `calc(50vw - 270px)`,
                    }
                  : {}
              }
            >
              {this.state.currentChapter}
            </p>
          )}
          {!this.state.isHideHeader && (
            <p
              className="header-book-name"
              style={
                this.state.isSingle
                  ? {
                      right: `calc(50vw - 270px)`,
                    }
                  : {}
              }
            >
              {this.state.percentage}%
            </p>
          )}
        </div>
        <div className="footer-container">
          {!this.state.isHideFooter && (
            <p
              className="background-page-left"
              style={
                this.state.isSingle
                  ? {
                      left: `calc(50vw - 270px)`,
                    }
                  : {}
              }
            >
              本章 第{this.state.chapterPage}頁/共{this.state.chapterTotal}頁
            </p>
          )}
          {!this.state.isHideFooter && !this.state.isSingle && (
            <p className="background-page-right">
              本章 第{this.state.chapterPageEnd}頁/共{this.state.chapterTotal}頁
            </p>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentEpub: state.book.currentEpub,
    currentBook: state.book.currentBook,
    flattenChapters: state.reader.flattenChapters,
    percentage: state.progressPanel.percentage,
  };
};
export default connect(mapStateToProps)(withRouter(Background));
